<script lang="ts">
  import translationsStore from '../../../stores/translations.svelte'
  import LiveStatusScreen from './LiveStatusScreen.svelte'
</script>

<LiveStatusScreen class="z-10">
  {translationsStore.state.live_not_started}
</LiveStatusScreen>
